// #18008 Piktogramm eines NHK-2010-Gebäudetyps 1.01–3.33 wie in der Sachwertrichtlinie, Anlage 1. Die 1. Ziffer
// (Bauweise) ändert das Piktogramm nicht; 2. Ziffer Geschosse (0 KG+EG, 1 KG+EG+OG, 2 EG, 3 EG+OG),
// 3. Ziffer Dach (1 DG ausgebaut, 2 DG nicht ausgebaut, 3 Flachdach).
const NHK_CODE = /^[123]\.([0-3])([1-3])$/;

export const isNhkHouseCode = (code: unknown): code is string => typeof code === "string" && NHK_CODE.test(code);

const WIDTH = 60;
const FLOOR = 22;
const ROOF = 30;
const MARGIN = 8;
const GROUND = MARGIN + ROOF + 2 * FLOOR;
const SVG_WIDTH = WIDTH + 2 * MARGIN;
const SVG_HEIGHT = GROUND + FLOOR * 0.7 + MARGIN;
const FILL = "#5f5f5f";

export default function NhkHouseSchema({
    code,
    className,
    scale = 1.5,
}: {
    code: string;
    className?: string;
    scale?: number;
}) {
    const [, storeys, roof] = NHK_CODE.exec(code) ?? [];
    const floors = storeys === "1" || storeys === "3" ? 2 : 1;
    const eaves = GROUND - floors * FLOOR;
    return (
        <svg
            viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
            width={SVG_WIDTH * scale}
            height={SVG_HEIGHT * scale}
            className={className}
            role="img"
            aria-label={code}
        >
            <g stroke="#1f1f1f" strokeWidth={2}>
                {roof !== "3" && (
                    <polygon
                        points={`${MARGIN},${eaves} ${MARGIN + WIDTH / 2},${eaves - ROOF} ${MARGIN + WIDTH},${eaves}`}
                        fill={roof === "1" ? FILL : "white"}
                    />
                )}
                {[GROUND - FLOOR, GROUND - 2 * FLOOR].slice(0, floors).map((y) => (
                    <rect key={y} x={MARGIN} y={y} width={WIDTH} height={FLOOR} fill={FILL} />
                ))}
                {(storeys === "0" || storeys === "1") && (
                    <rect x={MARGIN} y={GROUND} width={WIDTH} height={FLOOR * 0.7} fill="white" />
                )}
                <line x1={0} x2={SVG_WIDTH} y1={GROUND} y2={GROUND} />
            </g>
        </svg>
    );
}
